// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__KkeIt","error":"Textarea_error__3OKRx","readonly":"Textarea_readonly__2eGjK","disabled":"Textarea_disabled__yZcsa"};